<template>

<div id="app">

	<b-navbar toggleable="md" type="light" variant="light">

	  <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

	  <b-navbar-brand href="#/">crypto<i>THANG</i></b-navbar-brand>

	  <b-collapse is-nav id="nav_collapse">

	    <b-navbar-nav>
	    	<b-nav-item-dropdown text="Crypto Calculators" href="#/calculators/">
        		<b-dropdown-item href="#/calculators/bitcoin">Bitcoin Calculator (2-Way)</b-dropdown-item>
        		<b-dropdown-item href="#/calculators/altcoin">Altcoin Calculator (3-Way)</b-dropdown-item>
        	</b-nav-item-dropdown>
	      <b-nav-item href="#/paths/altcoin">Altcoin Path Finder</b-nav-item>

	    </b-navbar-nav>

	    <!-- Right aligned nav items -->
	    <b-navbar-nav class="ml-auto">

	    	<b-nav-item>

	    	</b-nav-item>

	    	<b-nav-item>

    		</b-nav-item>

	    	<!--
	      <b-nav-form>
	        <b-form-input size="sm" class="mr-sm-2" type="text" placeholder="Search"/>
	        <b-button size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
	      </b-nav-form>


	      <b-nav-item-dropdown text="Lang" right>
	        <b-dropdown-item href="#">EN</b-dropdown-item>
	        <b-dropdown-item href="#">ES</b-dropdown-item>
	        <b-dropdown-item href="#">RU</b-dropdown-item>
	        <b-dropdown-item href="#">FA</b-dropdown-item>
	      </b-nav-item-dropdown>


	      <b-nav-item-dropdown right>
	        <- Using button-content slot ->
	        <template slot="button-content">
	          <em>User</em>
	        </template>
	        <b-dropdown-item href="#">Profile</b-dropdown-item>
	        <b-dropdown-item href="#">Signout</b-dropdown-item>
	      </b-nav-item-dropdown>

	      -->
	    </b-navbar-nav>

	  </b-collapse>
	</b-navbar>

	<b-container fluid id="main-content">
	  <!-- Content here -->
	  <b-row>
	    <b-col cols="0"></b-col>
        <b-col>
        	<router-view/>
        </b-col>
        <b-col cols="0"></b-col>
      </b-row>
	</b-container>

	<b-container fluid id="alert-container">
		<b-row class="justify-content-center">
			<b-col cols="12" md="8">
				<div id="alerts">
					<b-alert v-for="alert in alerts" :variant="alert.variant" :show="alert.show" :dismissible="alert.dismissible" @dismissed="alert.show=false">{{alert.message}}</b-alert>
				</div>
			</b-col>
		</b-row>
	</b-container>


	<div class="footer-container">
	<site-footer />
	</div>
</div>

</template>

<script>

//import components
import SelectCurrency from '@/components/SelectCurrency';
import SelectExchanges from '@/components/SelectExchanges';
import SiteFooter from '@/components/SiteFooter';

export default {
  name: 'App',
  components: {
	  'select-currency': SelectCurrency,
	  'select-exchanges': SelectExchanges,
	  'site-footer': SiteFooter
  },

  data() {
      return {

      }
  },
  computed: {

	  alerts: function(){
		  return  this.$root.$store.getters.alerts;
	  }

  }

}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.primary-field {
	border: 1px solid #E6A23C;
}
.wrap-container {
	flex-wrap: wrap;
}
.box-card {
	max-width: 250px;
	margin: 5px;
}
.no-label {

	padding-top:40px
}

.white-space-nowrap {
	white-space: nowrap;
}

.results {
	width: 90%;
	margin: 10px;
}

#alert-container  {
	position: fixed;
	top: 20px;
	margin-left: auto;
	margin-right: auto;
}

#alerts  {
	margin-left: auto;
	margin-right: auto;
	z-index: 1000;
}

#main-content {
	background-color: #FFFFFF;
	opacity: 1;
	background-clip: border-box;
}

/* Spinner */
@-moz-keyframes spin {
    to { -moz-transform: rotate(359deg); }
}
@-webkit-keyframes spin {
    to { -webkit-transform: rotate(359deg); }
}
@keyframes spin {
    to {transform:rotate(359deg);}
}

.spin {
    animation: spin 1000ms linear infinite;
}

.favorite { color: gold !important}

.footer-container {
	height: 41px;
	margin-top: 5px;
}

.cursor-pointer {
	cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/App.vue